import React from 'react';

interface LanguageToggleProps {
  currentLang: string;
  onLanguageChange: (lang: string) => void;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ currentLang, onLanguageChange }) => {
  return (
    <div className="flex items-center space-x-1 bg-gray-100 rounded-full p-1">
      <button
        onClick={() => onLanguageChange('en')}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all duration-200 ${
          currentLang === 'en' 
            ? 'bg-white text-gray-900 shadow-sm' 
            : 'text-gray-600 hover:text-gray-900'
        }`}
        aria-label="English"
      >
        EN
      </button>
      <button
        onClick={() => onLanguageChange('ko')}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all duration-200 ${
          currentLang === 'ko' 
            ? 'bg-white text-gray-900 shadow-sm' 
            : 'text-gray-600 hover:text-gray-900'
        }`}
        aria-label="한국어"
      >
        KO
      </button>
    </div>
  );
};

export default LanguageToggle;